
import listTable from './tagTable.vue';

export default {
  components: {
    listTable: listTable
  },

  data: function data() {
    return {
      tabs: [{ label: '竞品标签', key: '1' }, { label: '动作描述', key: '2' }, { label: '模型风格', key: '3' }, { label: '动作类型', key: '5' }, { label: '图片类型', key: '6' }, { label: '视频类型', key: '7' }, { label: '音频类型', key: '8' }, { label: '配置标签', key: '13' }],
      currentTag: ''
    };
  },


  watch: {
    $route: function $route(to, from) {
      this.updateTag(to.query.tag);
    }
  },

  mounted: function mounted() {
    this.updateTag(this.$route.query.tag);
  },


  methods: {
    updateTag: function updateTag(tag) {
      if ([1, 2, 3, 5, 6, 7, 8, 13].indexOf(Number(tag)) === -1) {
        this.currentTag = '1';
        return;
      }
      if (!tag) {
        this.currentTag = '1';
        return;
      }
      this.currentTag = tag;
    },
    handleTabClick: function handleTabClick(tab) {
      this.$router.push({
        name: 'repo.tags',
        query: {
          tag: tab.name
        }
      });
    }
  }
};